const ENV = process.env.REACT_APP_ENV || ''
let clientID = '0oaui1bqqrvjFBAkO697'
if (ENV?.toLocaleLowerCase() === 'prod') {
  clientID = '0oav30m092QogkbOe697'
}

export const oktaConfig = {
  clientId: clientID,
  issuer: 'https://helpathome.okta.com',
  redirectUri: `${window.location.origin}/login/callback`,
  scopes: ['openid', 'profile', 'email'],
  pkce: true
}
